module.exports = __webpack_public_path__ + "img/fukushima.2c3decb9.png";